import { phoneRegExp } from "@/constants/common";

import * as yup from "yup";


export const partnershipSchema = yup.object({
  name: yup.string().required("Contact Person Name is required"),
  companyName: yup.string().required("Company name is required"),
  companyType: yup.string().required("Company type is required"),
  comments: yup.string().required("Comments are required"),
  jobTitle: yup.string().optional(),
  websiteUrl: yup.string().optional(),
  title: yup.string().optional(),
  subject: yup.string().optional(),
  country: yup.string().optional(),
  city: yup.string().optional(),
  email: yup.string().email("Invalid email").required("Email is required"),
  phone: yup.string().matches(phoneRegExp, "Invalid phone number").optional(),
});

export type PartnershipSchema = yup.InferType<typeof partnershipSchema>;

